import {Component, Input} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatTooltipModule} from '@angular/material/tooltip';
import {environment} from '../../../environments/environment';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-wiki-help-link',
    imports: [MatIconModule, MatButtonModule, MatTooltipModule, TranslateModule],
    template: `
    <a [href]="getUrl()"
       target="_blank"
       rel="noopener noreferrer"
       mat-icon-button
       [matTooltip]="'help.viewDocumentation' | translate"
       class="wiki-help-link">
      <mat-icon svgIcon="mat:help_outline"></mat-icon>
    </a>
  `,
    styles: [`
    .wiki-help-link {
      opacity: 0.6;
      transition: opacity 0.2s ease;
    }
    .wiki-help-link:hover {
      opacity: 1;
    }
  `]
})
export class WikiHelpLinkComponent {
  @Input({required: true}) path!: string;

  getUrl(): string {
    const baseUrl = environment.docs?.url || 'https://docs.telemann.de';
    return `${baseUrl}${this.path}`;
  }
}
